import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useAppSelector } from '../../redux/store';
import { BombsSubPanelContainer } from './bombsSubPanelContainer';
export const SelfBombsSubPanelContainer = () => {
    const myPlayerId = useAppSelector((state) => state.selfData.id);
    const myUsername = useAppSelector((state) => state.selfData.username);
    if (myPlayerId === undefined || myUsername === undefined) {
        return null;
    }
    const playerIdName = { id: myPlayerId, name: myUsername };
    return _jsx(BombsSubPanelContainer, { playerIdName: playerIdName, isSelfPanel: true });
};
